
const CustomIcon = ({ src, alt }) => {
  return <img src={src} alt={alt} style={{ width: "24px", height: "24px" }} />;
};

export default CustomIcon;
